let mode;

if (process.env.REACT_APP_MODE) {
  mode = process.env.REACT_APP_MODE;
} else {
  mode = "dev";
}
console.log("env", process.env);

var localURL = "http://localhost:3000/dev";

export var demoAuthUrl =
  "https://toyg4ps5yl.execute-api.us-east-1.amazonaws.com/dev";

// server_coreSetURL1;
export var awsUrl =
  "https://se6qso6svb.execute-api.us-east-1.amazonaws.com/dev";
var awsUrlBeta = "https://scjvkhegk2.execute-api.us-east-1.amazonaws.com/beta";
var awsUrlProd = "https://4wyxok15pi.execute-api.us-east-1.amazonaws.com/prod";
export var awsAcordUpload =
  "https://5swuplkv50.execute-api.us-east-1.amazonaws.com/dev";
var awsAcordUploadProd =
  "https://ofmfwmokg6.execute-api.us-east-1.amazonaws.com/prod";

// server_coreSetURL2;
export var awsUrl2 =
  "https://z4netv2dvj.execute-api.us-east-1.amazonaws.com/dev";
var awsUrlBeta2 = "https://b8eg5yv3b5.execute-api.us-east-1.amazonaws.com/beta";
var awsUrlProd2 = "https://exr72pihm9.execute-api.us-east-1.amazonaws.com/prod";

export var awsUrlBookUpload =
  "https://trhjf8s0w4.execute-api.us-east-1.amazonaws.com/dev";

// pibit URL dev & prod

export var pibitUrl =
  "https://qypm1jivib.execute-api.us-east-1.amazonaws.com/dev";
var pibitUrlBeta =
  "https://wy69228799.execute-api.us-east-1.amazonaws.com/beta";
var pibitUrlProd =
  "https://thcgya5ipc.execute-api.us-east-1.amazonaws.com/prod";

// for dev and beta environment client-id for all instances will be same, but it will differ in prod.
export var clientId = 103;
var clientIdProd = 110;

// This key is added in db to differentiate client, since for dev environment pibit will have single client code.
// Client code for prod will differ.
export var clientIdInternal = "103-12";
var clientIdInternalProd = 80;

// dashboard URL
export var dashboardUrl =
  "https://dmuwt3vd0e.execute-api.us-east-1.amazonaws.com/dev";
var dashboardUrlProd = "";
// mode = "local3"
if (mode === "local1") {
  awsUrl = localURL;
  awsAcordUpload = localURL;
} else if (mode === "local2") {
  awsUrl2 = localURL;
  awsAcordUpload = localURL;
} else if (mode === "local3") {
  awsUrlBookUpload = localURL;
  awsAcordUpload = localURL;
} else if (mode === "locald") {
  dashboardUrl = localURL;
} else if (mode === "prod") {
  awsUrl = awsUrlProd;
  awsUrl2 = awsUrlProd2;
  dashboardUrl = dashboardUrlProd;
  awsAcordUpload = awsAcordUploadProd;
} else if (mode === "beta") {
  awsUrl = awsUrlBeta;
  awsUrl2 = awsUrlBeta2;
  dashboardUrl = dashboardUrlProd;
  ((pibitUrl = pibitUrlBeta), (clientIdInternal = clientIdInternal));
} else if (mode === "dev") {
  pibitUrl = pibitUrl;
  clientId = clientId;
  clientIdInternal = clientIdInternal;
} else if (mode === "prod") {
  awsUrl = awsUrlProd;
  awsUrl2 = awsUrlProd2;
  dashboardUrl = dashboardUrlProd;
  pibitUrl = pibitUrlProd;
  clientId = clientIdProd;
  clientIdInternal = clientIdInternalProd;
  awsAcordUpload = awsAcordUploadProd;
}

export const versionNumber = "1.0.4 (m)";
